/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Carousel, CarouselWrapper, CarouselNavigation } from '@codex/organisms';
import {
  LAYOUT_1_0, LAYOUT_1_2, LAYOUT_2_0, LAYOUT_2_2
} from '../constants';
import UnstyledItem from './Item/index';

const Item = styled(UnstyledItem)``;

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  
  ${Item} {
    width: ${({ layout, ordersCount }) => ([LAYOUT_2_0, LAYOUT_2_2].includes(layout) && ordersCount > 1 ? '50%' : '100%')};
    margin-bottom: 0;
    overflow: hidden;
  }
  
  ${Item} + ${Item} {
    margin-left: ${({ theme }) => theme.spacing[2]};
  }
  
  @media ${({ theme }) => theme.breakpoints.wrapItems} {
    flex-direction: column;
    
    ${Item} {
      width: 100%;
    }
    
    ${Item} + ${Item} {
      margin-left: 0;
      margin-top: ${({ theme, inCarousel }) => (inCarousel ? 0 : theme.spacing[2])};
      position: ${({ inCarousel }) => (inCarousel ? 'absolute' : 'static')};
    }
  }
  
  ${CarouselWrapper} {
    border: ${({ theme }) => `1px solid ${theme.colors.shades[5]}`};
    background-color: ${({ theme }) => theme.colors.shades[7]};
  }
  
  ${CarouselNavigation} {
    margin-left: ${({ theme }) => theme.spacing[2]};
    margin-right: ${({ theme }) => theme.spacing[2]};
  }
`;

const RecentOrders = (props) => {
  const inCarousel = props.deviceType === 'mobile' && props.orders.length > 1;
  const Container = inCarousel ? Carousel : Fragment;

  return (
    <Wrapper inCarousel={inCarousel} className={props.className} layout={props.layout} ordersCount={props.orders.length}>
      <Container>
        {props.orders.map(order => (
          <Item
            appearance={inCarousel ? 'in-carousel' : 'box'}
            key={order.orderReference}
            mainProduct={order.singleOrders[0].products[0]}
            numberOfProducts={order.productsCount}
            orderDate={order.orderDate}
            orderReference={order.orderReference}
            orderStatus={order.singleOrders[0].officialOrderStatus}
            orderTitle={props.orderTitle}
            plusItemsMessage={props.plusItemsMessage}
            registerAccountMessageStart={props.registerAccountMessageStart}
            registerAccountMessageEnd={props.registerAccountMessageEnd}
            links={order.links}
            layout={props.layout}
            onRegisterAccountLinkClicked={e => props.onRegisterAccountLinkClicked(e, order)}
          />
        ))}
      </Container>
    </Wrapper>
  );
};

RecentOrders.propTypes = {
  className: PropTypes.string,
  deviceType: PropTypes.string,
  orders: PropTypes.arrayOf(PropTypes.shape({
    orderDate: PropTypes.string,
    orderReference: PropTypes.string,
    productsCount: PropTypes.number,
    singleOrders: PropTypes.arrayOf(PropTypes.shape({
      officialOrderStatus: PropTypes.shape({
        tag: PropTypes.string,
        positive: PropTypes.bool
      }),
      products: PropTypes.arrayOf(PropTypes.shape({
        productId: PropTypes.string,
        name: PropTypes.string,
        image: PropTypes.string,
        productUrl: PropTypes.string
      }))
    })),
    links: PropTypes.arrayOf(PropTypes.shape({}))
  })),
  orderTitle: PropTypes.string,
  plusItemsMessage: PropTypes.string,
  layout: PropTypes.oneOf([
    LAYOUT_1_0,
    LAYOUT_1_2,
    LAYOUT_2_0,
    LAYOUT_2_2
  ]).isRequired,
  onRegisterAccountLinkClicked: PropTypes.func,
  registerAccountMessageStart: PropTypes.string,
  registerAccountMessageEnd: PropTypes.string
};

RecentOrders.defaultProps = {
  className: undefined,
  deviceType: undefined,
  orders: [],
  orderTitle: UnstyledItem.defaultProps.orderTitle,
  plusItemsMessage: UnstyledItem.defaultProps.plusItemsMessage,
  onRegisterAccountLinkClicked: () => {},
  registerAccountMessageStart: UnstyledItem.defaultProps.registerAccountMessageStart,
  registerAccountMessageEnd: UnstyledItem.defaultProps.registerAccountMessageEnd
};

/** @component */
export default RecentOrders;
